import { CssBaseline, createTheme, ThemeProvider } from '@mui/material';
import React, { useMemo, useState } from 'react';
import AppThemeContext from './AppThemeContext';

export const AppThemeProvider = ({ children }: React.PropsWithChildren) => {
  const theme = useMemo(() => createTheme({
    palette: { primary: { main: '#3268d9' }, text: { primary: '#142d4e', secondary: '#58677b' }, background: { default: '#ffffff', paper: '#ffffff' } },
    typography: { fontFamily: 'Manrope, Arial, sans-serif', fontWeightRegular: 400, fontWeightMedium: 600, fontWeightBold: 700, button: { textTransform: 'none' } },
    shape: { borderRadius: 12 },
  }), []);
  const [padding, setPadding] = useState<React.CSSProperties>({paddingLeft: '24px', paddingRight: '24px'});
  return <ThemeProvider theme={theme}><CssBaseline /><AppThemeContext.Provider value={{ padding, setPadding }}>{children}</AppThemeContext.Provider></ThemeProvider>;
};
